// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__d6nrf","icon":"SortAdornment_icon__1e-vb","up":"SortAdornment_up__3kJ2q","down":"SortAdornment_down__3RR_r","active":"SortAdornment_active__p5vCJ"};